import { useState } from 'react';
import TurkishMainLayout from '@/components/layout/TurkishMainLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Card } from '@/components/ui/card';

const TurkishContactPage = () => {
  const [contactMethod, setContactMethod] = useState<'phone' | 'email'>('phone');
  return (
    <TurkishMainLayout>
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto">
          <Card className="p-6 md:p-8">
            <h1 className="text-3xl font-bold text-hotel-primary mb-2">Lobier'i Otelinizde Ücretsiz Deneyin</h1>
            <p className="text-gray-600 mb-8">Aşağıdaki formu doldurun, sizinle 1 iş günü içinde iletişime geçelim.</p>
            
            <form action="https://formsubmit.co/tamer.yilmaz.07@gmail.com" method="POST" target="_blank" className="space-y-6">
              {/* Honeypot */}
              <input type="text" name="_honey" style={{ display: 'none' }} />
              
              {/* Disable Captcha */}
              <input type="hidden" name="_captcha" value="false" />
              
              {/* Success Page */}
              <input type="hidden" name="_next" value={`${window.location.origin}/iletisim/basari`} />
              
              {/* Subject */}
              <input type="hidden" name="_subject" value="Yeni Lobier İletişim Talebi" />
              
              <div className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    Otel Adı *
                  </label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    required
                    placeholder="Otel adınızı girin"
                  />
                </div>

                <div>
                  <label htmlFor="contactName" className="block text-sm font-medium text-gray-700 mb-1">
                    İletişim Kişisi *
                  </label>
                  <Input
                    id="contactName"
                    name="contactName"
                    type="text"
                    required
                    placeholder="Adınızı ve soyadınızı girin"
                  />
                </div>
                <div className='text-sm font-semibold text-gray-700'>Nasıl iletişime geçmek istersiniz?</div>
                <div className='flex items-center'>
                    <div className='flex items-center gap-2 border border-slate-300 border-r-0 rounded-l-md p-2'>
                        <input
                            type="radio"
                            name="contactMethod"
                            id="phoneselect"
                            value="phone"
                            className='w-4 h-4'
                            checked={contactMethod === "phone"}
                            onChange={() => setContactMethod("phone")}
                        />
                        <label htmlFor="phoneselect" className="block text-sm font-medium text-gray-700 mb-0 mr-1">
                            Telefon
                        </label>
                    </div>
                  <div className='flex items-center gap-2 border border-slate-300 rounded-r-md p-2'>
                    <input
                        type="radio"
                        name="contactMethod"
                        id="emailselect"
                        value="email"
                        className='w-4 h-4'
                        checked={contactMethod === "email"}
                        onChange={() => setContactMethod("email")}
                    />
                    <label htmlFor="emailselect" className="block text-sm font-medium text-gray-700 mb-0">
                        E-posta
                    </label>
                  </div>
                </div>

                {contactMethod === "phone" && (
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                      Telefon Numarası *
                    </label>
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      required={contactMethod === "phone"}
                      placeholder="Telefon numaranızı girin"
                    />
                  </div>
                )}

                {contactMethod === "email" && (
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                      E-posta Adresi *
                    </label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      required={contactMethod === "email"}
                      placeholder="E-posta adresinizi girin"
                    />
                  </div>
                )}
              </div>

              <div className='text-xs text-gray-500'>Bilgileriniz yalnızca sizinle iletişime geçmek için kullanılacaktır.</div>
              <Button type="submit" className="w-full bg-hotel-primary hover:bg-hotel-primary/90">
                Mesaj Gönder
              </Button>
            </form>
          </Card>
        </div>
      </div>
    </TurkishMainLayout>
  );
};

export default TurkishContactPage; 